import AuthService from '@/services/AuthService';

export default function(to, from, next) {
    if(AuthService.isAuthorized || to.name === 'login') {
        next();
    } else {
        next('login');
    }
}